import { render } from "./LoaderRoute.vue?vue&type=template&id=0a5f911c&scoped=true"
const script = {}

import "./LoaderRoute.vue?vue&type=style&index=0&id=0a5f911c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5f911c"]])

export default __exports__